// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminReviewsManagement-space1-B1xm7 {
	margin-bottom: 6px !important;
}

.AdminReviewsManagement-space2-b6Ivs {
	margin-bottom: 12px !important;
}

.AdminReviewsManagement-space3-sn2va {
	margin-bottom: 18px !important;
}

.AdminReviewsManagement-space4-GRsGy {
	margin-bottom: 24px !important;
}

.AdminReviewsManagement-space5-_LwVl {
	margin-bottom: 30px !important;
}

.AdminReviewsManagement-space6-tWwPP {
	margin-bottom: 36px !important;
}

.AdminReviewsManagement-space7-yPXih {
	margin-bottom: 42px !important;
}

.AdminReviewsManagement-space8-BZuZE {
	margin-bottom: 48px !important;
}

.AdminReviewsManagement-spaceTop1-YiGuw {
	margin-top: 6px !important;
}

.AdminReviewsManagement-spaceTop2-vxwdQ {
	margin-top: 12px !important;
}

.AdminReviewsManagement-spaceTop3-QZ_bV {
	margin-top: 18px !important;
}

.AdminReviewsManagement-spaceTop4-cVmFT {
	margin-top: 24px !important;
}

.AdminReviewsManagement-spaceTop5-sm3UM {
	margin-top: 30px !important;
}

.AdminReviewsManagement-spaceTop6-Vkb5N {
	margin-top: 36px !important;
}

.AdminReviewsManagement-spaceTop7-bpyma {
	margin-top: 42px !important;
}

.AdminReviewsManagement-spaceTop8-O4DG6 {
	margin-top: 48px !important;
}

.AdminReviewsManagement-noMargin-zV6q2 {
	margin: 0px !important;
}

.AdminReviewsManagement-padding1-HJj_U {
	padding-bottom: 6px !important;
}

.AdminReviewsManagement-padding2-GrOCN {
	padding-bottom: 12px !important;
}

.AdminReviewsManagement-padding3-QV8WS {
	padding-bottom: 18px !important;
}

.AdminReviewsManagement-padding4-W3b__ {
	padding-bottom: 24px !important;
}

.AdminReviewsManagement-padding5-og2x2 {
	padding-bottom: 30px !important;
}

.AdminReviewsManagement-padding6-KMBjE {
	padding-bottom: 36px !important;
}

.AdminReviewsManagement-padding7-FU4Vf {
	padding-bottom: 42px !important;
}

.AdminReviewsManagement-paddingTop1-wCi_d {
	padding-top: 6px !important;
}

.AdminReviewsManagement-paddingTop2-Ec3uF {
	padding-top: 12px !important;
}

.AdminReviewsManagement-paddingTop3-wBsvb {
	padding-top: 18px !important;
}

.AdminReviewsManagement-paddingTop4-OTTl9 {
	padding-top: 24px !important;
}

.AdminReviewsManagement-paddingTop5-C5tkm {
	padding-top: 30px !important;
}

.AdminReviewsManagement-paddingTop6-ahayN {
	padding-top: 36px !important;
}

.AdminReviewsManagement-paddingTop7-YT9xj {
	padding-top: 42px !important;
}

.AdminReviewsManagement-noPadding-VtHr6 {
	padding: 0px !important;
}

.AdminReviewsManagement-spaceMarginBottom0-f5m5j {
	margin-bottom: 0;
}

.AdminReviewsManagement-textBold-dj_0L {
	font-weight: 500 !important;
}

.AdminReviewsManagement-textBolder-rzLtS {
	font-weight: 700 !important;
}

.AdminReviewsManagement-textNormal-PovMe {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminReviewsManagement-textDarkBlue-N61bH {
	color: rgb(20, 39, 94) !important;
}

.AdminReviewsManagement-textLightBlue-UPgaJ {
	color: rgb(57, 87, 106) !important;
}

.AdminReviewsManagement-textLightSandleGreen-UM8IW {
	color: rgb(76, 86, 41) !important;
}

.AdminReviewsManagement-textLightBrown-ScfVm {
	color: rgb(115, 79, 33) !important;
}

.AdminReviewsManagement-textMediumMaroon-Sjegx {
	color: rgb(87, 37, 51) !important;
}

.AdminReviewsManagement-textBrown-grvRb {
	color: rgb(160, 47, 24) !important;
}

.AdminReviewsManagement-textMaroon-UKMYz {
	color: rgb(155, 49, 67) !important;
}

.AdminReviewsManagement-textDarkBrown-pMAns {
	color: rgb(83, 18, 16) !important;
}

.AdminReviewsManagement-textMediumBrown-yklx2 {
	color: rgb(142, 28, 10) !important;
}

.AdminReviewsManagement-textSkyBlue-Rvbu3 {
	color: rgb(37, 117, 141) !important;
}

.AdminReviewsManagement-textGray-ltUIX {
	color: rgb(77, 65, 51) !important;
}

.AdminReviewsManagement-errorMessage-B59bf {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminReviewsManagement-userText-Kk0Nk {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminReviewsManagement-panelHeader-td5CZ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminReviewsManagement-exportSection-DCBJf {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminReviewsManagement-exportSectionGridSub-CQ88o {
	grid-template-columns: 50% 49% !important;
}

.AdminReviewsManagement-exportText-BUBHP {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminReviewsManagement-exportLinkImg-IKKIT {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminReviewsManagement-exportImg-Iyc3A {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminReviewsManagement-linkBtn-QTqv5 {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminReviewsManagement-table-_yjYI {
	display: table;
}

.AdminReviewsManagement-tableRow-TDqsD {
	display: table-row;
}

.AdminReviewsManagement-tableCell-YCJPK {
	display: table-cell;
	float: none;
}

.AdminReviewsManagement-formGroup-wzmqy {
	margin-bottom: 6px;
}

.AdminReviewsManagement-marginTop0-WEaCe {
	margin-top: 0;
}

.AdminReviewsManagement-marginBottom20-Q4CSn {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminReviewsManagement-bannerImageBg-rT5Cd {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminReviewsManagement-bannerDelete-deKFR {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminReviewsManagement-exportLink-xrw9h {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminReviewsManagement-seachContent-sv7y6 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminReviewsManagement-marginBottom9-xq8wB {
	margin-bottom: 9px;
}

.AdminReviewsManagement-spaceTop52-_3ZGo {
	margin-top: 52px;
}

.AdminReviewsManagement-profileViewInner-fVedE {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminReviewsManagement-profileViewMain-gKhSZ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminReviewsManagement-profileViewlabel-k_27c {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminReviewsManagement-profileViewMainContent-aQnNJ {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminReviewsManagement-reviewsFormStar-omf8y {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminReviewsManagement-reviewsFormStar-omf8y svg {
	cursor: pointer;
}

.AdminReviewsManagement-addLanguageText-xahTL {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminReviewsManagement-exportSection-DCBJf {
		grid-template-columns: 100%;
	}

	.AdminReviewsManagement-spaceTop52-_3ZGo {
		margin-top: 18px;
	}

	.AdminReviewsManagement-exportText-BUBHP {
		float: none;
		margin-top: 12px;
	}

	.AdminReviewsManagement-exportSectionGridSub-CQ88o {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminReviewsManagement-profileViewlabel-k_27c {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminReviewsManagement-profileViewMainContent-aQnNJ {
		width: 100%;
		text-align: center;
	}

	.AdminReviewsManagement-panelHeader-td5CZ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/
`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminReviewsManagement-space1-B1xm7`,
	"space2": `AdminReviewsManagement-space2-b6Ivs`,
	"space3": `AdminReviewsManagement-space3-sn2va`,
	"space4": `AdminReviewsManagement-space4-GRsGy`,
	"space5": `AdminReviewsManagement-space5-_LwVl`,
	"space6": `AdminReviewsManagement-space6-tWwPP`,
	"space7": `AdminReviewsManagement-space7-yPXih`,
	"space8": `AdminReviewsManagement-space8-BZuZE`,
	"spaceTop1": `AdminReviewsManagement-spaceTop1-YiGuw`,
	"spaceTop2": `AdminReviewsManagement-spaceTop2-vxwdQ`,
	"spaceTop3": `AdminReviewsManagement-spaceTop3-QZ_bV`,
	"spaceTop4": `AdminReviewsManagement-spaceTop4-cVmFT`,
	"spaceTop5": `AdminReviewsManagement-spaceTop5-sm3UM`,
	"spaceTop6": `AdminReviewsManagement-spaceTop6-Vkb5N`,
	"spaceTop7": `AdminReviewsManagement-spaceTop7-bpyma`,
	"spaceTop8": `AdminReviewsManagement-spaceTop8-O4DG6`,
	"noMargin": `AdminReviewsManagement-noMargin-zV6q2`,
	"padding1": `AdminReviewsManagement-padding1-HJj_U`,
	"padding2": `AdminReviewsManagement-padding2-GrOCN`,
	"padding3": `AdminReviewsManagement-padding3-QV8WS`,
	"padding4": `AdminReviewsManagement-padding4-W3b__`,
	"padding5": `AdminReviewsManagement-padding5-og2x2`,
	"padding6": `AdminReviewsManagement-padding6-KMBjE`,
	"padding7": `AdminReviewsManagement-padding7-FU4Vf`,
	"paddingTop1": `AdminReviewsManagement-paddingTop1-wCi_d`,
	"paddingTop2": `AdminReviewsManagement-paddingTop2-Ec3uF`,
	"paddingTop3": `AdminReviewsManagement-paddingTop3-wBsvb`,
	"paddingTop4": `AdminReviewsManagement-paddingTop4-OTTl9`,
	"paddingTop5": `AdminReviewsManagement-paddingTop5-C5tkm`,
	"paddingTop6": `AdminReviewsManagement-paddingTop6-ahayN`,
	"paddingTop7": `AdminReviewsManagement-paddingTop7-YT9xj`,
	"noPadding": `AdminReviewsManagement-noPadding-VtHr6`,
	"spaceMarginBottom0": `AdminReviewsManagement-spaceMarginBottom0-f5m5j`,
	"textBold": `AdminReviewsManagement-textBold-dj_0L`,
	"textBolder": `AdminReviewsManagement-textBolder-rzLtS`,
	"textNormal": `AdminReviewsManagement-textNormal-PovMe`,
	"textDarkBlue": `AdminReviewsManagement-textDarkBlue-N61bH`,
	"textLightBlue": `AdminReviewsManagement-textLightBlue-UPgaJ`,
	"textLightSandleGreen": `AdminReviewsManagement-textLightSandleGreen-UM8IW`,
	"textLightBrown": `AdminReviewsManagement-textLightBrown-ScfVm`,
	"textMediumMaroon": `AdminReviewsManagement-textMediumMaroon-Sjegx`,
	"textBrown": `AdminReviewsManagement-textBrown-grvRb`,
	"textMaroon": `AdminReviewsManagement-textMaroon-UKMYz`,
	"textDarkBrown": `AdminReviewsManagement-textDarkBrown-pMAns`,
	"textMediumBrown": `AdminReviewsManagement-textMediumBrown-yklx2`,
	"textSkyBlue": `AdminReviewsManagement-textSkyBlue-Rvbu3`,
	"textGray": `AdminReviewsManagement-textGray-ltUIX`,
	"errorMessage": `AdminReviewsManagement-errorMessage-B59bf`,
	"userText": `AdminReviewsManagement-userText-Kk0Nk`,
	"panelHeader": `AdminReviewsManagement-panelHeader-td5CZ`,
	"exportSection": `AdminReviewsManagement-exportSection-DCBJf`,
	"exportSectionGridSub": `AdminReviewsManagement-exportSectionGridSub-CQ88o`,
	"exportText": `AdminReviewsManagement-exportText-BUBHP`,
	"exportLinkImg": `AdminReviewsManagement-exportLinkImg-IKKIT`,
	"exportImg": `AdminReviewsManagement-exportImg-Iyc3A`,
	"linkBtn": `AdminReviewsManagement-linkBtn-QTqv5`,
	"table": `AdminReviewsManagement-table-_yjYI`,
	"tableRow": `AdminReviewsManagement-tableRow-TDqsD`,
	"tableCell": `AdminReviewsManagement-tableCell-YCJPK`,
	"formGroup": `AdminReviewsManagement-formGroup-wzmqy`,
	"marginTop0": `AdminReviewsManagement-marginTop0-WEaCe`,
	"marginBottom20": `AdminReviewsManagement-marginBottom20-Q4CSn`,
	"bannerImageBg": `AdminReviewsManagement-bannerImageBg-rT5Cd`,
	"bannerDelete": `AdminReviewsManagement-bannerDelete-deKFR`,
	"exportLink": `AdminReviewsManagement-exportLink-xrw9h`,
	"seachContent": `AdminReviewsManagement-seachContent-sv7y6`,
	"marginBottom9": `AdminReviewsManagement-marginBottom9-xq8wB`,
	"spaceTop52": `AdminReviewsManagement-spaceTop52-_3ZGo`,
	"profileViewInner": `AdminReviewsManagement-profileViewInner-fVedE`,
	"profileViewMain": `AdminReviewsManagement-profileViewMain-gKhSZ`,
	"profileViewlabel": `AdminReviewsManagement-profileViewlabel-k_27c`,
	"profileViewMainContent": `AdminReviewsManagement-profileViewMainContent-aQnNJ`,
	"reviewsFormStar": `AdminReviewsManagement-reviewsFormStar-omf8y`,
	"addLanguageText": `AdminReviewsManagement-addLanguageText-xahTL`
};
module.exports = ___CSS_LOADER_EXPORT___;
